import GoneRecipePage from '../../../src/views/GoneRecipePage'
import { decodeRecipeId, serverSideRequest } from '../../../src/helpers'

export async function getServerSideProps({ res, params, locale }) {
  res.statusCode = 410
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=60, stale-while-revalidate=119',
  )

  const decodedRecipeId = decodeRecipeId(params.recipeId)
  const availabilityZoneId = process.env.NEXT_PUBLIC_AVAILABILITY_ZONE
  const { data: recipe } = await serverSideRequest({
    name: 'getRecipe',
    recipeId: decodedRecipeId,
    availabilityZoneId,
    language: locale,
    locale,
    withSimilarRecipes: true,
  })

  if (!recipe) {
    return {
      notFound: true,
    }
  }

  const { data: featuredRecipes } = await serverSideRequest({
    name: 'getFeaturedRecipes',
    availabilityZoneId,
    locale,
  })

  return {
    props: {
      title: recipe.title || '',
      similarRecipes: (recipe.similarRecipes || [])
        .filter((r) => r.isVisible)
        .slice(0, 5),
      featuredRecipes: (featuredRecipes || []).slice(0, 5),
    },
  }
}

const GoneRecipe = ({ similarRecipes, featuredRecipes, title }) => {
  return (
    <GoneRecipePage
      similarRecipes={similarRecipes}
      featuredRecipes={featuredRecipes}
      title={title}
    />
  )
}

GoneRecipe.getAppLayoutProps = () => ({ pageId: 'RECIPE' })

export default GoneRecipe
